import { CardsConfiaPage } from './ConfiaPage';
import { CardsSignedPage } from './SignedPage';
import { CardsEnrichPersonalData } from './EnrichPersonalData';
import { CardsLogin } from './Login';
import { CardsBenefitCards } from './BenefitCards';
import { CardsPersonalDocument } from './PersonalDocument';
import { CardsLoading } from './Loading';

export const CardsTheme = {
    ConfiaPage: CardsConfiaPage,
    SignedPage: CardsSignedPage,
    EnrichPersonalData: CardsEnrichPersonalData,
    Login: CardsLogin,
    BenefitCards: CardsBenefitCards,
    PersonalDocument: CardsPersonalDocument,
    Loading: CardsLoading,
} as const;